// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1fee11d4","547":"4d1e8f65"}[chunkId] + ".chunk.js";
};